import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "@/App";
import './styles/fonts.css';
import "@/styles/global.css";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ToastProvider } from "@/components/common/toast";
import { persistor, store } from "@/store/store.ts";
import { AuthProvider } from "@/providers/AuthProvider";
import ErrorBoundary from "./components/error/ErrorBoundary.tsx";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

if (!PUBLISHABLE_KEY) {
    throw new Error("Missing Publishable Key");
}

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
                    <AuthProvider>
                        <ErrorBoundary>
                            <ToastProvider>
                                <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY} language="en">
                                    <App />
                                </GoogleReCaptchaProvider>
                            </ToastProvider>
                        </ErrorBoundary>
                    </AuthProvider>
                </ClerkProvider>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);